import { ReactNode, useCallback, useState } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import PlainModal, { PlainModalContent, PlainModalFooter, PlainModalHeader } from 'app/common/ui-next/plain-modal'
import IframeResizer from 'iframe-resizer-react'

import styles from './Offer.module.scss';
import ControlsBar from 'app/common/ui-next/controls-bar'


type Props = {
  offerURL: string | null
  closeButtonTitle?: string
  children: (toggle: () => void) => ReactNode
}

const Offer = ({ offerURL, closeButtonTitle = 'Закрыть', children }: Props) => {
  const [viewModal, setViewModal] = useState(false)
  const toggle = useCallback(() => {
    setViewModal(x => !x)
  }, [])

  return (
    <>
      {viewModal
        && <PlainModal className={styles.root} show>
          <PlainModalHeader>
            {'\u00A0'}
          </PlainModalHeader>
          <PlainModalContent>
            <IframeResizer
              title="offer"
              src={`${offerURL}?iframeSizer=true`}
              scrolling={false}
              className={styles.frame}
            />
          </PlainModalContent>
          <PlainModalFooter>
            <ControlsBar middle>
              <PlainButton onClick={toggle}>{closeButtonTitle}</PlainButton>
            </ControlsBar>
          </PlainModalFooter>
        </PlainModal>}
      {children(toggle)}
    </>
  )
}

export default Offer
